import React, { useState } from "react";
import {
	IonPage,
	IonHeader,
	IonToolbar,
	IonTitle,
	IonContent,
	IonButton,
	IonBackButton,
	IonLabel,
	IonInput,
	IonCard,
	IonCardContent,
	IonSelect,
	IonSelectOption,
	IonIcon,
	IonTextarea,
	IonLoading,
	IonToast,
	IonDatetime,
} from "@ionic/react";
import { chevronBack, createOutline } from "ionicons/icons";
import { ENDPOINT } from "../../Credentials/credentials";
import "./Enrollment.css";
const Enrollment = () => {
	const [formData, setFormData] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [showToast1, setShowToast1] = useState(false);
	const [showToast2, setShowToast2] = useState(false);

	const handleInput = (e) => {
		const copyFormData = { ...formData };
		copyFormData[e.target.name] = e.target.value;
		setFormData(copyFormData);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			console.log(formData);
			const response = await fetch(ENDPOINT, {
				method: "post",
				body: JSON.stringify([
					[
						formData.name,
						formData.dob,
						formData.gender,
						formData.guardianname,
						formData.homeaddress,
						formData.schoolname,
						formData.phonenumber,
						formData.emailid,
						formData.bloodgroup,
						formData.mediclaimid,
					],
				]),
				headers: {
					"Content-Type": "application/json",
				},
			});
			const json = await response.json();
			console.log("Success :", JSON.stringify(json));
			const whatsappMsg = `Dear Victor , New Student Enrolled Name: - ${formData.name} Guardian Name :- ${formData.guardianname} Guardian Phone number :- ${formData.phonenumber}`;
			window.location = `https://api.whatsapp.com/send?phone=919804221906&text=${whatsappMsg}`;
			setIsLoading(false);
			setShowToast1(true);
		} catch (error) {
			console.error("Error", error);
			setIsLoading(false);
			setShowToast2(true);
		}
	};
	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButton mode="ios" fill="clear" slot="start">
						<IonBackButton
							mode="ios"
							icon={chevronBack}
							text="Back"
							color="tertiary"
							defaultHref="/joinus/"
						/>
					</IonButton>
					<IonTitle>Enrollment Form</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<IonCard className="bg">
					<form onSubmit={handleSubmit} className="bg-child">
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								name="name"
								onIonChange={handleInput}
								placeholder="Name"
								type="text"
								style={{ marginLeft: "5%" }}
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonDatetime
								name="dob"
								onIonChange={handleInput}
								mode="ios"
								displayTimezone="Asia/Kolkata"
								placeholder="Date Of Birth"
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonSelect
								name="gender"
								onIonChange={handleInput}
								placeholder="Gender"
								aria-required="true"
							>
								<IonSelectOption value="Male">
									Male
								</IonSelectOption>
								<IonSelectOption value="Female">
									Female
								</IonSelectOption>
								<IonSelectOption value="Other">
									Other
								</IonSelectOption>
							</IonSelect>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								onIonChange={handleInput}
								name="guardianname"
								placeholder="Guardian Name"
								type="text"
								style={{ marginLeft: "3%" }}
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonTextarea
								onIonChange={handleInput}
								name="homeaddress"
								placeholder="Home Address"
								style={{ marginLeft: "3%" }}
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								onIonChange={handleInput}
								name="schoolname"
								placeholder="School / College Name"
								style={{ marginLeft: "3%" }}
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								name="phonenumber"
								onIonChange={handleInput}
								style={{ marginLeft: "3%" }}
								placeholder="Phone Number"
								type="tel"
								minlength={10}
								maxlength={10}
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								name="emailid"
								onIonChange={handleInput}
								style={{ marginLeft: "3%" }}
								placeholder="Email Id"
								type="email"
								required={true}
							/>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonSelect
								name="bloodgroup"
								onIonChange={handleInput}
								placeholder="Blood Group"
								aria-required="true"
							>
								<IonSelectOption value="A +ve">
									A +ve
								</IonSelectOption>
								<IonSelectOption value="A +ve">
									A -ve
								</IonSelectOption>
								<IonSelectOption value="B +ve">
									B +ve
								</IonSelectOption>
								<IonSelectOption value="B +ve">
									B -ve
								</IonSelectOption>
								<IonSelectOption value="AB +ve">
									AB +ve
								</IonSelectOption>
								<IonSelectOption value="AB +ve">
									AB -ve
								</IonSelectOption>
								<IonSelectOption value="O +ve">
									O +ve
								</IonSelectOption>
								<IonSelectOption value="O -ve">
									O -ve
								</IonSelectOption>
							</IonSelect>
						</IonCardContent>
						<IonCardContent
							style={{ display: "block", textAlign: "left" }}
						>
							<IonInput
								name="mediclaimid"
								onIonChange={handleInput}
								style={{ marginLeft: "3%" }}
								placeholder="Mediclaim Id (Optional)"
								type="text"
							/>
						</IonCardContent>
						<IonCardContent>
							<IonButton
								mode="ios"
								onClick={() => setIsLoading(true)}
								shape="round"
								expand="full"
								type="submit"
							>
								<IonIcon mode="ios" icon={createOutline} />
								&nbsp;&nbsp;
								<IonLabel mode="ios"> Register </IonLabel>
							</IonButton>
						</IonCardContent>
					</form>
				</IonCard>
				<IonLoading
					spinner="bubbles"
					isOpen={isLoading}
					onDidDismiss={() => setIsLoading(false)}
					message="Please Wait ...."
				/>
				<IonToast
					isOpen={showToast1}
					onDidDismiss={() => setShowToast1(false)}
					message="Your Registration Was Successful !! You Can Now Go Back"
					duration={5000}
				/>
				<IonToast
					isOpen={showToast2}
					onDidDismiss={() => setShowToast2(false)}
					message="Your Registration Was Unsuccessful !! Please Try Again Later"
					duration={5000}
				/>
			</IonContent>
		</IonPage>
	);
};

export default Enrollment;
